/**
 * Return the global native browser window obj
 * @returns {Window}
 * @private
 */
export function getWindow(): any {
  return window;
}
